import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetPurchaseByVendorQuery } from "../../../services/Reports";
import {
  getPurchaseByVendorRequest,
  getPurchaseByVendorFailure,
  getPurchaseByVendorSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allPurchaseByVendor,
    isLoading: purchaseByVendorLoading,
    isError: purchaseByVendorError,
  } = useGetPurchaseByVendorQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.purchaseByVendorPageNo,
    pageSize: state.purchaseByVendorPageSize,
    fromDate: new Date(state.purchaseByVendorFromDate).toLocaleDateString(),
    toDate: new Date(state.purchaseByVendorToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (purchaseByVendorLoading) {
      dispatch(getPurchaseByVendorRequest());
    }
    if (purchaseByVendorError) {
      dispatch(getPurchaseByVendorFailure(purchaseByVendorError));
    }
    if (allPurchaseByVendor) {
      dispatch(
        getPurchaseByVendorSuccess({
          data: allPurchaseByVendor.data.purchaseByVendor[0].data || [],
          totalPages:
            allPurchaseByVendor.data.purchaseByVendor[0].metadata[0]?.total ||
            0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allPurchaseByVendor,
    profileData,
    state.purchaseByVendorFromDate,
    state.purchaseByVendorToDate,
    state.purchaseByVendorPageNo,
    state.purchaseByVendorPageSize,
  ]);
  return <></>;
};
export default Content;
